import * as React from 'react'
import { SectionHeader } from '../entity/SectionHeader'
import { SessionGhostRow, useVisibleGhostRels } from '../session-mark-ui'

/** Struck, non-navigating rows for relationships deleted in the current session. */
export function DeletedRelationshipsSection({
  entityId
}: {
  entityId: string
}): React.ReactElement | null {
  const rows = useVisibleGhostRels(entityId)
  if (rows.length === 0) return null
  const deletedCount = rows.filter((row) => row.view === 'deleted').length

  return (
    <section>
      <SectionHeader
        label="Deleted this session"
        subtitle={`${deletedCount} ${deletedCount === 1 ? 'relationship' : 'relationships'}`}
      />
      <div className="rounded-xl border bg-card p-5 text-card-foreground shadow-sm">
        <div className="flex flex-col gap-1.5">
          {rows.map(({ relId, peerName, view }) => (
            <SessionGhostRow key={relId} name={peerName} view={view} />
          ))}
        </div>
      </div>
    </section>
  )
}
